export var DocumentUploadsExperience;
(function (DocumentUploadsExperience) {
    DocumentUploadsExperience["FALLBACK"] = "fallback";
    DocumentUploadsExperience["DIRECT"] = "direct";
    DocumentUploadsExperience["DISABLED"] = "disabled";
})(DocumentUploadsExperience || (DocumentUploadsExperience = {}));
export var DocumentUploadsType;
(function (DocumentUploadsType) {
    // Note: these should be kept consistent with `DocumentType` in shared-python.
    DocumentUploadsType["PAYSTUB"] = "paystub";
    DocumentUploadsType["W2"] = "W-2";
})(DocumentUploadsType || (DocumentUploadsType = {}));
export var DocumentUploadsStatus;
(function (DocumentUploadsStatus) {
    DocumentUploadsStatus["QUEUED"] = "queued";
    DocumentUploadsStatus["UPLOADING"] = "uploading";
    DocumentUploadsStatus["UPLOADED"] = "uploaded";
    DocumentUploadsStatus["FAILED"] = "failed";
    DocumentUploadsStatus["ERROR"] = "error";
})(DocumentUploadsStatus || (DocumentUploadsStatus = {}));
export var DocumentUploadsValidationError;
(function (DocumentUploadsValidationError) {
    DocumentUploadsValidationError["MAX_FILE_SIZE_EXCEEDED"] = "max_file_size_exceeded";
    DocumentUploadsValidationError["UNSUPPORTED_FILE_TYPE"] = "unsupported_file_type";
})(DocumentUploadsValidationError || (DocumentUploadsValidationError = {}));
